import * as React from "react";
const SvgCabin = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", style: {
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  imageRendering: "optimizeQuality",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, viewBox: "0 0 512 512", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M135.5-.5h240v40h-40v72h80v357h-40v43h-40v-40h-160v40h-40v-43h-40v-357h80v-72h-40v-40Zm80 40h80v72h-80v-72Zm-80 112h240c.167 20.003 0 40.003-.5 60-1.167 11.833-7.667 18.333-19.5 19.5-66.667.667-133.333.667-200 0-11.833-1.167-18.333-7.667-19.5-19.5-.5-19.997-.667-39.997-.5-60Zm0 117a31.543 31.543 0 0 0 9 2.5c10.328.5 20.661.666 31 .5v40h40v-40h80v40h40v-40c10.339.166 20.672 0 31-.5a24.909 24.909 0 0 0 8.5-2.5c.5 54.332.667 108.666.5 163h-240v-163Z", style: {
  opacity: 1
} }));
export default SvgCabin;
